<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
import { useMagicKeys, whenever } from '@vueuse/core'
import Swal from "sweetalert2";
import exportFromJSON from "export-from-json";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Inventário",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Loader, Layout, PageHeader, Multiselect },
  data() {
    return {
      title: "Editar Inventário",
      items: [
        {
          text: "Inventários",
          href: "/movinvents/list",
        },
        {
          text: "Editar Inventário",
          active: true
        }
      ],

      idData: 0,
      updating: true,
      updatingListas: false,
      wmsOsListData: null,
      movInventData: {
        id: 0,
        status: "EL",
        dtemissao: new Date,
        tipo: "soma"
      },

      movInventItemData: {},
      movInventItensData: {},

      wmsOsItemData: {},

      submitted: false,
      errosValid: null,
      tipoConferencia: 'A',
      enderecoData: null,
      dtlistPesqEndereco: null,

      dtListProdSugest: null,
      updatingPesqProd: false,
      flagPdf: false,
    }
  },
  created() {



  },
  mounted() {
    const keys = useMagicKeys()

    whenever(keys.alt_s, () => {
      this.$refs.produto.focus()
    })

    whenever(keys.alt_r, () => {
      this.reiniciar()
    })

    whenever(keys.alt_z, () => {
      this.finalizar()
    })
    console.log('mounted_inventario_editar')
    let rota = this.$route.path
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){
      this.carregarDados()
    }else{
      this.title = `Criando Novo Inventário`
      this.updating = false
    }
  },
  methods: {
    salvar() {
      console.log('salvar')

      if (this.movInventData.status === "EL") {
        api.post(`${getBaseUrl()}api/movinvent`, {
            movinventdata: this.movInventData,
            movinventitemdata: this.movInventItemData
          }).then((res) => {
            console.log('then axios salvar')
            console.log(JSON.stringify(res.data))
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
      }
    },

    selecionarPesq(dataProd){
      console.log('selecionarPesq')


      this.movInventItemData.produto = dataProd.codigo
      this.movInventItemData.descprod = dataProd.descricao
      this.$refs.produto.focus()


    },



    editarProd(prod) {
      console.log('editarProd')

      this.movInventItemData.id = prod.id
      this.movInventItemData.endwms = prod.endwms
      this.movInventItemData.produto = prod.produto
      this.movInventItemData.descprod = prod.descprod

      this.$refs.qtd.focus()

      this.dtlistPesqEndereco = [
        {
          'codigo': prod.endwms,
          'descricao': prod.endwms
        },
      ]


    },


    deletarItem(dataID) {
      console.log('deletarItem')

      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          this.updating = true
          api.delete(`${getBaseUrl()}api/movinventitem`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })

    },




    informouQtd() {
      console.log('informouQtd')
      console.log(this.movInventItemData)
      this.movInventItemData.empresa = this.movInventData.empresa

      if (this.movInventItemData.descprod && this.movInventItemData.endwms) {

        this.updatingListas = true

        api.post(`${getBaseUrl()}api/movinventitem`, {
          'iddata': this.idData,
          'movinventdata': this.movInventData,
          'item': this.movInventItemData
        }).then((res) => {
          console.log('then axios confitem')
          console.log(this.idData)
          console.log(res.data)
          this.updatingListas = false

          if (this.idData === 0){
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Inventário iniciado com sucesso!",
              showConfirmButton: false,
              timer: 2000
            }).then(() => {
              this.idData = res.data[0][0].movinvent_id
              this.$router.replace('/movinvent/editar/' + this.idData)
            })
          }

          this.movInventData.nome_empresa = res.data[1].emprnome

          this.movInventItensData = res.data[0]
          this.movInventItemData.produto = null
          this.movInventItemData.descprod = null
          this.movInventItemData.qtd = null
          this.dtListProdSugest = null
          this.$refs.produto.focus()
        })


      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Obrigatório informar produto, endereço e  quantidade, favor corrigir.",
          showConfirmButton: false,
          timer: 2500
        })
      }


    },


    pesqEndereco(evt) {
      console.log('pesqEndereco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        // this.loadingPedTipo = true
        // this.wmsOsItemSepData.endwms = ''
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "movinvent", origem_id: this.movInventData.id }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqEndereco = res.data
        })
      }
    },


    escolheuEndereco() {
      console.log('escolheuEndereco')
      console.log(this.movInventItemData.endwms)
      this.$refs.lote.focus()
    },



    finalizar() {
      console.log('finalizar')
      if (this.movInventItensData.length > 0) {

        Swal.fire({
          position: "center",
          icon: "question",
          title: "Finalizar Conferência",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.updating = true

            // console.log(result.value)
            // console.log('vai')
            // this.wmsOsItemData['idwmsos'] = this.idData
            // this.updatingListas = true
            //
            api.post(`${getBaseUrl()}api/movinventfinalsep`, {
              'iddata': this.idData
            }).then((res) => {
              console.log('then axios separar2_0')
              console.log(res.data)
              this.movInventData = res.data[0]
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Comando Finalizar executado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
              this.updating = false
            })
          }
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Necessário adicionar item ao inventário, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    reiniciar() {
      console.log('reiniciar')

    },

    informouLote(){
      console.log('informouLote')
      this.$refs.produto.focus()

    },

    informouProduto() {
      console.log('informouProduto')

      console.log(this.movInventItemData.produto)
      this.updatingPesqProd = true
      if (this.movInventItemData.produto) {
        api.get(`${getBaseUrl()}api/prodcodcoletor`, {
          params: {
            coddata: this.movInventItemData.produto,
            empresa: this.movInventData.empresa
          }
        }).then((res) => {
          console.log('then axios prodcod')
          console.log(res.data)

          this.updatingPesqProd = false

          if(res.data.success === true) {
            this.movInventItemData.produto_id = res.data.data.id
            this.movInventItemData.descprod = res.data.data.descricao
            this.movInventItemData.saldo = res.data.data.saldo

            if (this.movInventItemData.descprod && this.movInventItemData.endwms && this.movInventData.tipoconf === 'A') {

              this.informouQtd()

            } else {

              this.$refs.qtd.focus()
            }
          } else {

            this.movInventItemData.descprod = null
            this.movInventItemData.id = null

            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500
            })
          }
        })
      }
    },


    carregarDados(){

      api.get(`${getBaseUrl()}api/movinvent`, {
        params: {
          iddata: this.idData
        }
      }).then((res) => {
        console.log('then axios wmsosEditar')
        console.log(res.data)
        this.movInventData = res.data[0]
        this.movInventItensData = res.data[1]
        if (this.movInventItensData.length > 0) this.flagPdf = true

        this.idData = this.movInventData.id
        this.title = `Editar Inventário (${this.movInventData.id})`
        this.updating = false
      })
    },





    nomeStatusWms(stsIn){
      let result = 'Não Conferido'
      switch (stsIn) {
        case 'SE':
          result = 'Conferido'
          break
      }
      return result
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    imprimirPdf() {
      console.log('imprimirPdf');

      api.post(`${getBaseUrl()}api/movinventrelatorio`, {
        'iddata': this.idData
      }, {
        responseType: 'arraybuffer'
      })
        .then((res) => {

          const contentType = res.headers['content-type'];

          if (contentType && contentType.includes('application/pdf')) {

            const fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
            const fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', `itenssepardos${String(this.idData)}.pdf`);
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);

          } else if (contentType && contentType.includes('application/json')) {

            const decoder = new TextDecoder('utf-8');
            const text = decoder.decode(res.data);
            const jsonResponse = JSON.parse(text);

            console.error('Erro ao gerar PDF:', jsonResponse.message);

          } else {
            console.error('Erro desconhecido: tipo de resposta inesperado.');
          }
        })
        .catch(error => {
          console.error('Erro na requisição:', error);
        });
    },

    exportExcel(){
      console.log('exportExcel')
      const data = this.movInventItensData
      .map((item) => {
        return {
          ID: item.id,
          Produto: item.produto,
          Descrição: item.descprod ?? "",
          Unidade: item.unidade ?? "",
          Endereço: item.endwms ?? "",
          Lote: item.lote ?? "",
          Quantidade: item.qtd ?? "",
          Valor_Unitário: item.vlrunit ?? "",
          Valor_Total: item.vlrtotal ?? "",
        }
      })
      const fileName = "relatorio_inventario" + String(this.idData)
      const exportType = exportFromJSON.types.xls
      if (data) exportFromJSON({ data, fileName, exportType })
    },

  },

};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="movInventData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>



    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="col-xl-8 w-100" v-if="!updating">
      <div class="card">
        <div class="card-body">
          <h5 class="mx-2 mb-4"><span class="text-trucad font-size-14 me-1">Empresa:  </span>{{this.movInventData.nome_empresa ?? "Não Definida"}}</h5>
          <div class="d-flex align-items-start">
            <b-button variant="outline-primary" class="mx-2" @click="salvar" :disabled="movInventData.status !== 'EL'">
              <i class="bx bx-save font-size-16 align-middle me-2"></i>
              Salvar
            </b-button>

            <b-button variant="outline-primary" class="mx-2" @click="reiniciar" :disabled="true">
              <i class="bx bx-sync font-size-16 align-middle me-2"></i>
              Reiniciar (alt + R)
            </b-button>

            <button class="btn btn-success" :disabled="movInventData.status !== 'EL' && idData  > 0" @click="finalizar">
              <i class="mdi mdi-check me-1 text-end"></i>
              Finalizar (alt + Z)
            </button>

            <b-button 
                variant="outline-warning" 
                class="mx-2"
                @click="imprimirPdf"
                v-if="flagPdf"
              >
              <i class="bx bx-printer font-size-16 align-middle me-2"></i>
              PDF separação 
            </b-button>

            <b-button 
              variant="outline-primary" 
              class="mx-2"
              @click="exportExcel"
              v-if="movInventItensData.length > 0"
            >
                <i class="bx bx-export font-size-16 align-middle "></i>
                Exportar Excel
            </b-button>
          </div>
        </div>

        <div class="card-body">
          <div class="col-sm-4">
            <div class="mb-3">
              <label for="tipo">Tipo de inventário</label>
              <select id="tipo" v-model="movInventData.tipo" class="form-control"
                      :disabled="movInventData.status !== 'EL'">
                <option value="sobrepor">Sobreposição (Zera histório e recomeça com inventário)</option>
                <option value="soma">Soma (Acréscimo ao estoque atual)</option>
                <option value="recontar" disabled>Recontagem (Estoque vs Inventário - Gera ajustes caso diferença)</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row" v-if="!updating">


      <div class="col-xl-8 w-100">

        <b-card-text>
          <div class="card">
            <div class="card-body"

            >
              <!--              <h4 class="card-title">Informações Principais</h4>-->
              <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

              <form class="needs-validation">
                <div class="row">


                  <div class="col-md-3">
                    <div class="mb-3">
                      <div class="mb-2">
                        <span class="text-black font-18 ">Endereço</span>
                      </div>

                      <multiselect id="endereco"
                                   ref="endwms"
                                   @search-change="pesqEndereco"
                                   @select="escolheuEndereco"
                                   v-model="movInventItemData.endwms"
                                   placeholder="Pesquisar endereços"
                                   :options="dtlistPesqEndereco"
                                   :searchable="true"
                                   :disabled="movInventData.status !== 'EL'"
                                   label="descricao"
                                   track-by="descricao"
                                   value-prop="descricao">
                        <template #option="slotProps">
                          <div class="row">
                            <div>
                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                              <span class="mx-4" >
                              {{ slotProps.option.endereco }}
                            </span>
                            </div>
                            <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                            <span class="mx-4" >
                            </span>
                            <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                          </div>
                        </template>
                      </multiselect>
                      <div v-if="submitted && !movInventItemData.endereco">
                        <span class="text-danger font-size-11">Campo endereço obrigatório, favor preencher.</span>
                      </div>


                    </div>

                  </div>


                  <div class="col-sm-3">
                    <div class="mb-3">
                      <label for="lote">Lote</label>
                      <input
                          id="lote"
                          v-model="movInventItemData.lote"
                          type="text"
                          ref="lote"
                          class="form-control"
                          :disabled="movInventData.status !== 'EL'"
                          @keypress.enter="informouLote"/>

                    </div>
                  </div>


                  <div class="col-sm-3">
                    <div class="mb-3">
                      <label for="produto">Código|EAN do Item</label>
                      <input
                          id="produto"
                          v-model="movInventItemData.produto"
                          type="text"
                          ref="produto"
                          class="form-control"
                          placeholder="Produto (alt + S)"
                          @keypress.enter="informouProduto"
                          :disabled="movInventData.status !== 'EL'"
                          :class="{'is-invalid': submitted && !movInventItemData.produto}"/>
                      <div v-if="submitted && !movInventItemData.produto"
                           class="invalid-feedback">
                        <span>Campo produto obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>




                  <div class="col-sm-3">
                    <div class="mb-3">
                      <label for="qtd">Quantidade </label>
                      <input
                          id="qtd"
                          ref="qtd"
                          v-model="movInventItemData.qtd"
                          type="number"
                          class="form-control"
                          :disabled="tipoConferencia === 'A' || movInventData.status !== 'EL'"
                          @keypress.enter="informouQtd"
                          placeholder="Quantidade a ser lida"/>
                    </div>
                  </div>


                  <div class="col-sm-6">
<!--                    <div class="mb-3">-->
<!--                      <label for="qtd">Quantidade de Itens</label>-->
<!--                      <input-->
<!--                          id="qtd"-->
<!--                          v-model="movInventItemData.qtd"-->
<!--                          type="number"-->
<!--                          :disabled="true"-->
<!--                          class="form-control"-->
<!--                          placeholder="Quantidade de Itens"/>-->
<!--                    </div>-->
                  </div>



                  <div class="col-sm-6">
                    <div class="mb-3 align-items-end align-content-end float-end">
                      <h5 class="font-size-14">Conferência</h5>
                      <b-form-checkbox
                          switch size="lg"
                          value="A"
                          unchecked-value="I"
                          :disabled="movInventData.status !== 'EL'"
                          v-model="tipoConferencia">
                        {{ tipoConferencia === 'A' ? 'Auto' : 'Manual' }}
                      </b-form-checkbox>
                    </div>
                  </div>



                  <div class="row">


                    <div class="col-sm-9">
                      <div class="mb-3">
                        <label for="descprod">Descrição Produto</label>
                        <input
                            id="descprod"
                            v-model="movInventItemData.descprod"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Descrição Produto"/>
                      </div>
                    </div>


                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="saldo">Saldo</label>
                        <input
                            id="saldo"
                            v-model="movInventItemData.saldo"
                            type="number"
                            :disabled="true"
                            class="form-control text-end"
                            placeholder="Saldo"/>
                      </div>
                    </div>


                  </div>




                </div>

              </form>


              <Loader v-if="updatingListas" style="min-height: 200px;">
              </Loader>



            </div>
          </div>

        </b-card-text>


      </div>


      <div class="col-xl-4">

        <Loader v-if="updatingPesqProd" style="min-height: 200px;">
        </Loader>

        <b-card-text v-if="dtListProdSugest !== null && dtListProdSugest.length > 0">
          <div class="card">
            <div class="card-body">
              <!--              <h4 class="card-title">Informações Principais</h4>-->
              <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

              <div class="row mb-2">

                <h4 class="card-title">Produtos pesquisa ({{ dtListProdSugest !== null ? dtListProdSugest.length : 0 }})</h4>

                <div class="table-responsive" v-if="!updatingPesqProd">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                    <tr>
                      <th>Produto</th>
                      <th>Descrição</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="data in dtListProdSugest" :key="data.id">

                      <td>

                        <img v-if="data.img1"
                             :src="data.img1"
                             alt="product-img"
                             title="product-img"
                             class="avatar-md" />

                        <div class="mb-3" v-else>
                          <i class="bx bxs-camera-off h2 text-warning" title="Produto sem foto"></i>
                        </div>

                      </td>

                      <td>
                        <h5 class="font-size-12 text-truncate">
                          <a href="javascript: void(0);" @click="selecionarPesq(data)" class="text-body fw-bold text-wrap">
                            {{ data.descricao }}
                          </a>
                        </h5>


                        <h6 class="text-muted mb-0">Sku: {{ data.codigo  }}


                        </h6>


                        <h6 class="text-black-50 mb-0">{{ data.unidade  }} </h6>
                        <h5 class="font-size-12 text-truncate text-end">

                        </h5>

                        <h6 class="text-muted mb-0"> {{ data.codbarra  }} </h6>


                        <h5 class="font-size-12 text-truncate text-end">
                          <b-button variant="outline-success" @click="selecionarPesq(data)">
                            <i class="mdi mdi-check d-block font-size-16"></i>
                          </b-button>
                        </h5>
                      </td>


                    </tr>



                    </tbody>
                  </table>
                </div>

              </div>

            </div>
          </div>

        </b-card-text>


      </div>


    </div>



    <div class="row" v-if="!updating">

      <div class="col-xl-8 w-100">

        <b-card-text>
          <div class="card">
            <div class="card-body">
              <!--              <h4 class="card-title">Informações Principais</h4>-->
              <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

              <div class="row mb-2">

                <Loader v-if="updatingListas" style="min-height: 200px;">
                </Loader>

                <h4 class="card-title">Produtos do inventário ({{ movInventItensData !== null ? movInventItensData.length : 0 }})</h4>

                <div class="table-responsive" v-if="!updatingListas">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                    <tr>
                      <th>Produto</th>
                      <th>Descrição</th>
                      <th>Endereço</th>
                      <th>Lote</th>
                      <th class="text-end">Quantidade</th>
                      <th class="text-end">Ações</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="data in movInventItensData" :key="data.id">

                      <td>
                        <h6 class="text-muted mb-0">{{ data.produto  }} </h6>
                        <img v-if="data.img1"
                             :src="data.img1"
                             alt="product-img"
                             title="product-img"
                             class="avatar-md" />

                        <div class="mb-3" v-else>
                          <i class="bx bxs-camera-off h2 text-warning" title="Produto sem foto"></i>
                        </div>

                      </td>

                      <td>
                        <h5 v-if="movInventData.status === 'EL'" class="font-size-12 text-truncate">
                          <a href="javascript: void(0);"  @click="editarProd(data)" class="text-body fw-bold text-wrap">
                            {{ data.descprod }}
                          </a>
                        </h5>
                        <h5 v-else class="font-size-12 text-truncate">
                          {{ data.descprod }}
                        </h5>
                      </td>

                      <td>
                        <h5 class="font-size-12 text-truncate">
                          {{ data.endwms }}
                        </h5>
                      </td>

                      <td>
                        <h5 class="font-size-12 text-truncate">
                          {{ data.lote }}
                        </h5>
                      </td>

                      <td>
                        <h5 class="font-size-12 text-truncate text-end">
                          {{ formatDecimal(data.qtd) }}
                        </h5>
                      </td>

                      <td>
                        <h5 class="font-size-12 text-truncate text-end" v-if="movInventData.status === 'EL'">
                          <b-button variant="outline-danger" @click="deletarItem(data.id)">
                            <i class="mdi mdi-trash-can d-block font-size-16"></i>
                          </b-button>
                        </h5>
                      </td>

                    </tr>



                    </tbody>
                  </table>
                </div>

              </div>

            </div>
          </div>

        </b-card-text>


      </div>

    </div>


  </Layout>
</template>
